var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_aura_profile_aura_prod_awsext_repsrv_com_remoteEntry_mjs_815f2b2b__;